var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutWrap',[_c('Header'),_vm._v(" "),_c('PageWrap',[_c('Nuxt'),_vm._v(" "),_c('Sidebar')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }